import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Star } from 'lucide-react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const ReviewSection = () => {
  const reviews = [
    {
      id: 1,
      name: "Deven Vekariya",
      role: "Director",
      
      text: "Denial Enterprise delivered our EVCS project with technical precision; their HT/LT connectivity expertise is unmatched for large-scale MNC infrastructure."
    },
    {
      id: 2,
      name: "Dhirubhai Patel",
      role: "Manager, Field Engineer",
     
      text: "Reliable vendor for substation building and meter upgrades; they maintain a 99% uptime that keeps our facility operations running smoothly."
    },
    {
      id: 3,
      name: "Vishva Vekariya",
      role: "Assistent",
      
      text: "The team simplified our entire site transition; their 4-step workflow made managing complex electrical upgrades effortless and efficient."
    }
  ];

  return (
    <section className="review py-10 bg-lightgreen position-relative rounded-bottom-0 rounded3">
      <div className="overlay"></div>
      <div className="container position-relative">
        <div className="review-inner pt-10 text-center text-lg-start">
          <div className="row align-items-center gy-5 gx-lg-5">
            <div className="col-lg-5">
              <div className="section-left">
                <div className="section-title mb-6">
                  <h6 className="text-uppercase fw-medium green1 mb-1">Client Reviews</h6>
                  <h2 className="ps-4 border-start border-3 border-green mb-4">
                    Client Success Stories:  <span className="green">Empowering the EV Journey</span>
                  </h2>
                </div>
                <div className="section-body">
                  <p>Our "Client Story"  highlights real-world experiences from satisfied EV drivers and business managers who have embraced sustainable transportation. These testimonials serve as social proof, showcasing how our smart charging solutions—from home setups to high-speed DC stations—have simplified daily routines and improved operational efficiency.</p>
                  <a href="/testimonals" className="btn btn2 mt-6">View all reviews</a>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="section-right">
                <div className="review-slider mb-4">
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 3000 }}
                    pagination={{ clickable: true }}
                    breakpoints={{
                      768: { slidesPerView: 1 }
                    }}
                  >
                    {reviews.map((review) => (
                      <SwiperSlide key={review.id}>
                        <div className="review-box mx-2 position-relative px-6 py-8 bg-white border-dashed border-2 rounded2">
                          <div className="qoute-icon p-4 h2 bg-lightgreen1 position-absolute rounded2">
                            <i><i className="fa fa-quote-right green" aria-hidden="true"></i></i>
                          </div>
                          <div className="review-info position-relative">
                            <ul className="list-unstyled d-flex">
                              {[...Array(5)].map((_, i) => (
                                <li key={i} className="me-1">
                                  <i className="fa fa-star black" aria-hidden="true"></i>
                                </li>
                              ))}
                            </ul>
                            <p className="h5 fw-normal fst-italic lh-base my-6">
                              {review.text}
                            </p>
                          </div>
                          <div className="reviewer-bio  align-items-center justify-content-center">
                            
                            <div className="bio-detail">
                              <span className="black text-uppercase fw-medium">{review.name}</span> <br />
                              <span className="green1">{review.role}</span>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                
                <div className="review-bottom d-flex align-items-center">
                  <ul className="list-unstyled d-flex me-3">
                    {[...Array(5)].map((_, i) => (
                      <li key={i}><i className="fa fa-star green" aria-hidden="true"></i></li>
                    ))}
                  </ul>
                  <p>
                    <span className="fw-bold">99.9% Customer Satisfaction</span> based on 50+ reviews of 25+ Completed Projects, and 25+ Happy Customers trust us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewSection;